import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import _ from 'lodash';
import Select from 'react-select';
import Validator from '../../../common/forms/Validator';
import ErrorMessage from '../../../common/forms/ErrorMessage';
import { getDetailedUser } from '../../../../actions/users';
import { getLanguagesList } from '../../../../actions';
import { createNewEmployer } from '../../../../actions/employers';
import { getLocationsListAction, createNewLocation } from '../../../../actions/locations';
import { searchCompaniesByName, getCompanyDepartments, editCompanyAction } from '../../../../actions/companies';
import { visuallyFormatPhoneNumber } from '../../../../helpers/general';
import {
  extractContactData,
  extractContactLocationData,
  extractIndividualContactData
} from '../../../../helpers/contacts';
import { appPath } from '../../../../constants';
import AddressInputAutoComplete from '../../../common/AddressInputAutoComplete';
import Loader from '../../../common/ui/Loader';
import Close from '../../../common/ui/Close';
import SwitchRow from '../../../common/forms/SwitchRow';
import FormActionButtons from '../../../common/forms/FormActionButtons';

class CreateContact extends Validator {
  constructor (props) {
    super(props);

    this.state = {
      is_company: true,
      is_cc_exempt: false,
      company_id: null,
      department_id: null,
      language_id: null,
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      password: 'GravyTemp2020',
      temp_password: true,
      address: '',
      city: '',
      state: '',
      zip: '',
      address_coordinates: '',
      isLoading: true,
      isPristine: true
    };

    this.handleCompaniesInput = _.debounce(this.handleCompaniesInput, 500);
  }

  handleChangeSelect = event => {
    const { name, value } = event.target;
    this.setState({
      employerDetails: {
        ...this.state.employerDetails,
        [name]: parseInt(value, 10)
      }
    });
  };

  validationRules = {
    email: { email: true },
    first_name: { required: true },
    last_name: { required: true },
    phone: { required: true },
    password: { password: true },
    language_id: { required: true }
  };

  _validate = () => {
    if (this.state.is_company) {
      this.validationRules.company_id = { required: true };
    } else {
      this.validationRules.address = { required: true };
    }

    if (this._checkDepartments()) {
      this.validationRules.department_id = { required: true };
    }

    return this.validate(this.validationRules);
  };

  handleSubmit = event => {
    event.preventDefault();

    if (this._validate()) {
      this._setDataIsLoading();

      this.props.createNewEmployer(extractContactData(this.state))
        .then(({ principalId }) => {
          if (principalId) {
            return this.handleIndividual(principalId).then(() => {
              this._setDataLoaded();
              this.props.toggleModal();
              this.navigateToEmployerDetails(principalId);
            });
          }
          this._setDataLoaded();
        });
    }
  };

  navigateToEmployerDetails = id => this.props.history.push(`/${appPath}/employers/${id}`);

  handleIndividual = async id => {
    if (!this.state.is_company) {
      await this.props.getDetailedUser(id)
        .then(data => Promise.all([
          this.props.editCompanyAction(data.company_id, extractIndividualContactData(this.state)),
          this.props.createNewLocation(extractContactLocationData({ ...this.state, company_id: data.company_id }, this.props.locationTypes))
        ]));
    }

    return id;
  };

  handleChange = event => {
    this.setFormIsTouched();

    const value = event.target.name === 'phone' ? visuallyFormatPhoneNumber(event.target.value) : event.target.value;

    this.setState({ [event.target.name]: value });
  };

  handleSwitch = name => this.setState(prevState => ({ [name]: !prevState[name] }));

  handleCompaniesInput = input => {
    if (input.length >= 3) {
      this.props.searchCompaniesByName(input);
    }
  };

  handleChangeCompany = option =>
    this.setState({ company_id: option ? option.value : null }, () => {
      if (this.state.company_id) {
        this.props.getCompanyDepartments(this.state.company_id);
      }
    });

  handleChangeDepartment = option => this.setState({ department_id: option ? option.value : null });

  handleChangeAddress = address => this.setState({ ...address });

  _setDataIsLoading = () => this.setState({ isLoading: true });

  _setDataLoaded = () => this.setState({ isLoading: false });

  _checkDepartments = () => {
    return this.state.is_company && this.props.departments.length;
  };

  componentDidMount () {
    Promise.all([
      this.props.getLanguagesList(),
      this.props.getLocationsListAction()
    ]).then(this._setDataLoaded);
  }

  cancel = () => {
    this._resetErrors();
    this.setState({
      is_company: false,
      is_cc_exempt: false,
      company_id: null,
      department_id: null,
      language_id: null,
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      password: '',
      temp_password: true,
      address: '',
      city: '',
      state: '',
      zip: '',
      address_coordinates: ''
    });
    this.props.toggleModal();
  };

  render () {
    const { languagesList, isOpen, toggleModal } = this.props;
    const { is_cc_exempt, is_company, company_id, department_id, isLoading } = this.state;
    const errors = this.validationErrors;

    return (
      <div>
        <Modal isOpen={isOpen} toggle={toggleModal}>
          <form onSubmit={this.handleSubmit} className={`form-create-contact ${isLoading ? 'is-loading' : ''}`}>
            <div className='modal-header'>
              <div className='modal-title'>New Contact</div>
              <Close onClick={toggleModal} />
            </div>
            <ModalBody>
              <div className='form-group'>
                <SwitchRow
                  label='This contact is a business'
                  checked={is_company}
                  onChange={() => this.handleSwitch('is_company')}
                />
              </div>

              {is_company && (
                <div className='form-group'>
                  <label className='mb-1'>Select Company</label>
                  <Select
                    onChange={this.handleChangeCompany}
                    onInputChange={this.handleCompaniesInput}
                    options={this.props.companiesData.map(company => ({ label: company.company_name, value: company.id }))}
                    value={company_id}
                    placeholder={'Enter Company Name'}
                  />
                  <ErrorMessage errorText={errors.company_id} />
                </div>
              )}

              {this._checkDepartments() ? (
                <div className='form-group'>
                  <label className='mb-1'>Select Department</label>
                  <Select
                    onChange={this.handleChangeDepartment}
                    options={this.props.departments.map(department => ({ label: department.name, value: department.id }))}
                    value={department_id}
                    placeholder={'Choose Department'}
                  />
                  <ErrorMessage errorText={errors.department_id} />
                </div>
              ) : null}

              <div className='form-group'>
                <label className='mb-1'>First Name</label>
                <input name='first_name' className='input-picker' value={this.state.first_name} onChange={this.handleChange} />
                <ErrorMessage errorText={errors.first_name} />
              </div>

              <div className='form-group'>
                <label className='mb-1'>Last Name</label>
                <input name='last_name' className='input-picker' value={this.state.last_name} onChange={this.handleChange} />
                <ErrorMessage errorText={errors.last_name} />
              </div>

              <div className='form-group'>
                <label className='mb-1'>Email</label>
                <input name='email' className='input-picker' value={this.state.email} onChange={this.handleChange} type='email' />
                <ErrorMessage errorText={errors.email} />
              </div>

              <div className='form-group'>
                <label className='mb-1'>Phone</label>
                <input name='phone' className='input-picker' value={this.state.phone} onChange={this.handleChange} type='tel' />
                <ErrorMessage errorText={errors.phone} />
              </div>

              <div className='form-group'>
                <label className='mb-1'>Password</label>
                <input name='password' className='input-picker' value={this.state.password} onChange={this.handleChange} type='password' />
                <ErrorMessage errorText={errors.password} />
              </div>

              <div className='form-group'>
                <SwitchRow
                  label='Force Password Reset'
                  checked={this.state.temp_password}
                  onChange={() => this.handleSwitch('temp_password')}
                />
              </div>

              {!is_company && (
                <Fragment>
                  <div className='form-group'>
                    <SwitchRow
                      label='Credit Card Not Required'
                      checked={is_cc_exempt}
                      onChange={() => this.handleSwitch('is_cc_exempt')}
                    />
                  </div>
                  <div className='form-group'>
                    <AddressInputAutoComplete handleAddressChange={this.handleChangeAddress} addressInfo={this.state} />
                    <ErrorMessage errorText={errors.address} />
                  </div>
                </Fragment>
              )}

              {languagesList.length && (
                <div className='form-group'>
                  <div className='mb-1'>Language</div>
                  {languagesList.map(lang => (
                    <label className='form-check form-check-inline' key={lang.id}>
                      <input className='form-check-input' type='radio' name='language_id' value={lang.id} onChange={this.handleChange} />
                      <span className='form-check-label'>{lang.language_name}</span>
                    </label>
                  ))}
                  <ErrorMessage errorText={errors.language_id} />
                </div>
              )}

              <FormActionButtons onClickCancel={this.cancel} submitTitle='Save' isSubmitDisabled={this.isPristine} />
            </ModalBody>
            { isLoading && <Loader /> }
          </form>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    languagesList: state.languagesList,
    locationTypes: state.locations.locationsList,
    companiesData: state.companies.searchResults,
    departments: state.companies.companyDetails.departments
  };
};

const mapDispatchToProps = {
  createNewEmployer,
  getLanguagesList,
  getLocationsListAction,
  searchCompaniesByName,
  getCompanyDepartments,
  getDetailedUser,
  createNewLocation,
  editCompanyAction
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateContact);



// WEBPACK FOOTER //
// ./src/components/app/employersList/CreateContact/index.js